import BaseModalView from "scripts/views/baseModalView";
import templateFacetedSearchFullTextMenuItem from "templates/search/facetedSearchOptionsMenuItem.hbs";

class FacetedSearchOptionsMenuItemView extends BaseModalView {
  get events() {
    return {
      "change .faceted-search-checkbox": "onCheckboxChange",
      "click .faceted-search-facet-clear-btn": "onClearClicked",
    };
  }

  get className() {
    return "faceted-search-menu-item";
  }

  get template() {
    return templateFacetedSearchFullTextMenuItem;
  }

  render() {
    const searchField = this.model.get("searchField");

    const fullText = searchField ? searchField.isFullText : false;
    const titleOnly = searchField && searchField.field === "t";

    this.$el.html(
      this.template({
        fullText,
        titleOnly,
      }),
    );

    return this;
  }

  onCheckboxChange(event) {
    const isChecked = event.currentTarget.checked;
    const $target = $(event.currentTarget);

    const $checkboxLabel = $target.parent().find("label.checkbox");
    if (isChecked) {
      //-- Reset both checkboxes
      this.clearCheckboxes();
      if ($target.val() === "fullText") {
        $("#titleOnly").prop("checked", false);
      } else {
        $("#fullText").prop("checked", false);
      }

      //-- Set the visual checkbox to checked.
      $checkboxLabel.addClass("checked");
    } else {
      $checkboxLabel.removeClass("checked");
    }

    this.triggerSearchUpdate();
  }

  onClearClicked() {
    this.trigger("clearAll");
  }

  triggerSearchUpdate() {
    const searchField = this.model.get("searchField");

    const isTitleOnly = $("#titleOnly").prop("checked");
    const isFullText = $("#fullText").prop("checked");

    this.trigger("apply", {
      term: searchField ? searchField.term : "*",
      field: isTitleOnly ? "t" : "g",
      isFullText,
    });
  }

  clearCheckboxes() {
    this.$el.find("label.checkbox").removeClass("checked");
  }
}

export default FacetedSearchOptionsMenuItemView;
